export class Page {
  current: number;
  size: number;
  totalItems?: number;

  static default() {
    return new Page(50);
  }

  static withSize(size: number) {
    return new Page(size);
  }

  private constructor(size: number) {
    this.current = -1;
    this.size = size || 50;
  }

  nextPage(): Page {
    this.current++;
    return this;
  }

  reset(): Page {
    this.current = -1;
    delete this.totalItems;

    return this;
  }
}
